import dayjs from "dayjs";
import { Bell } from "lucide-react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useQuery } from "react-query";
import { Link, useLocation } from "react-router-dom";
import { auth } from "../firebase";
import {
  useMarkAllNotificationsAsRead,
  useNotifications,
  useUserPartnerInformation,
} from "../hooks";
import { useClickOutside } from "../hooks/useClickOutside";
import { getUnreadNotifications } from "../services/users/users.api";
import { ReactComponent as FrydaLogo } from "./../assets/logo/Fryda_logo.svg";


export function Header() {
  const [user] = useAuthState(auth);

  const { userPartnerInformation } = useUserPartnerInformation(user?.uid);

  const {
    dropdownRef: notificationRef,
    isDropdownVisible: openNotifications,
    setIsDropdownVisible: setOpenNotifications,
  } = useClickOutside(false);

  const { notifications } = useNotifications();


  const notificationList = notifications?.data?.notifications ?? [];

  const { data: unreadNotifications } = useQuery(
    "unreadNotifications",
    () => getUnreadNotifications(userPartnerInformation?.data?.partnerId),
    {
      enabled: !!userPartnerInformation?.data?.partnerId,
    }
  );

  const { markAllNotificationsAsRead } = useMarkAllNotificationsAsRead();

  const location = useLocation();

  return (
    <header className="flex items-center justify-between ml-20 px-10 pt-7">
      <div className="flex items-center justify-start">
        <FrydaLogo className="w-13" />
      </div>
      <div className="flex items-center gap-6">
        {/* Language Switcher */}


        {/* Notifications */}
        <div className="relative">
          <Bell
            className="w-6 h-6 cursor-pointer"
            onClick={() => setOpenNotifications((curr: any) => !curr)}
          />
          {unreadNotifications?.data?.hasUnreadNotifications && (
            <span className="absolute -top-1.5 right-[2px] w-2 h-2 rounded-full bg-indigo-500" />
          )}
        </div>

        {openNotifications && (
          <div
            ref={notificationRef}
            className="absolute top-20 right-2 mt-2 bg-white rounded-md shadow-lg overflow-hidden z-20 pb-2"
            style={{ width: "40rem" }}
          >
            <div className="flex items-center justify-between p-3 border-b border-gray-100">
              <h1 className="text-lg font-semibold">Notifications</h1>
              <button
                className="text-gray-500 text-sm"
                onClick={() =>
                  markAllNotificationsAsRead(
                    userPartnerInformation?.data?.partnerId
                  )
                }
              >
                Mark all as read
              </button>
            </div>
            <div className="overflow-y-auto" style={{ height: "25rem" }}>
              {notificationList.map((notification, index) => (
                <Link
                  state={{ previousLocation: location }}
                  to={{
                    pathname: `/dpc/${notification.dpcId}`,
                    search: `?serviceId=${notification.reference}`,
                  }}
                  key={index}
                  className="flex flex-col justify-start border px-4 py-2 hover:bg-gray-100 cursor-pointer"
                >
                  <span className="text-gray-800 font-semibold mb-1">
                    {notification.title}
                  </span>
                  <span className="text-gray-400 text-sm text-start mb-4">
                    {notification.message}
                  </span>
                  <span className="text-gray-400 text-xs">
                    {dayjs(notification.createdAt).format("DD MMM")}
                  </span>
                </Link>
              ))}
              {!notificationList.length && (
                <div className="flex items-center justify-center">
                  <p className="text-gray-400 text-sm">
                    No notifications found
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
